import {
    FrontendExperimentsResponse,
    Identifiers
} from "@atlassian/feature-gate-node-client-bootstrapper";

export type FeatureGatesBootstrapValues = FrontendExperimentsResponse & {
    identifiers: Identifiers;
};

declare global {
    interface Window {
        featureGateBootstrapValues: FeatureGatesBootstrapValues;
    }
}

export enum StatsigFeatureGateKey {
    BXPSU_2854_CONFLUENCE_PUBLIC_LINK = "bxpsu-2854_confluence_public_link", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    BXPSU_2930_SITE_PICKER_BXP_UI = "bxpsu-2930_site_picker_bxp_ui", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2930_site_picker_bxp_ui
    BXPSU_3087_JIRA_JSM_BXP_UI = "bxpsu-3087_jira_jsm_bundle_sign_up_white_bg", // https://switcheroo.atlassian.com/gates/c0a8aa5d-9af9-4ff0-bca8-c62611bc1c15
    ST_34007_SPORK_MIGRATION = "st-34007_spork_migration" // https://switcheroo.atlassian.com/gates/58941d2d-b0c8-46b9-bc08-0f7026e9afdd
}

export enum StatsigExperimentKey {
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW = "bxpsu-2628-remove-bundles-nonpaid-jsw-signup", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu-2628-remove-bundles-nonpaid-jsw-signup
    WAC_SIGNUP_UPGRADE_PATH = "wac_signup_upgrade_path", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    BXPSU_2791_ALLOW_SITE_EXPANSION_EXPERIMENT = "bxpsu-2791-allow-site-expansion-sign-ups", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu-2791-allow-site-expansion-sign-ups
    JFIND_SANDBOX_M1 = "jfind-sandbox-m1", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-sandbox-m1
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS = "jfind-transparent-template-for-all-teams" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-transparent-template-for-all-teams
}

// Recommend to prefix cohort names with experiment ticket (ex. expcen-1234_variation-1)
export enum StatsigExperimentCohort {
    UNEXPECTED_FAILURE = "unexpected_failure",
    NOT_ENROLLED = "not_enrolled",
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW_CONTROL = "control",
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW_VARIANT = "bxpsu-2628-remove-bundles",
    WAC_SIGNUP_UPGRADE_PATH_TEST = "test",
    BXPSU_2791_ALLOW_SITE_EXPANSION_EXPERIMENT_CONTROL = "control",
    BXPSU_2791_ALLOW_SITE_EXPANSION_EXPERIMENT_VARIANT = "bxpsu-2791-allow-site-expansion-signups",
    JFIND_SANDBOX_M1_CONTROL = "control",
    JFIND_SANDBOX_M1_VARIANT = "jfind-sandbox-m1",
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS_CONTROL = "control",
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS_VARIANT = "variant"
}
